import { useEffect, useState } from "react";
import { useBeforeUnload, useBlocker } from "react-router";

export const useNavigationBlock = (isBlocked: boolean) => {
  const [wasCancelled, setWasCancelled] = useState(false);
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => isBlocked && currentLocation.pathname !== nextLocation.pathname
  );

  useBeforeUnload(event => {
    if (!isBlocked) return;
    event.preventDefault();
    event.returnValue = "";
    return "";
  });

  const cancel = () => {
    blocker.reset?.();
    setWasCancelled(true);
  };

  useEffect(() => {
    !isBlocked && setWasCancelled(false);
  }, [isBlocked]);

  useEffect(() => {
    if (blocker.state !== "blocked" || isBlocked) return;
    blocker.reset();
    setWasCancelled(true);
  }, [blocker, isBlocked]);

  const proceed = () => {
    setWasCancelled(false);
    blocker.proceed?.();
  };

  return {
    proceed,
    cancel,
    state: blocker.state === "blocked" ? "blocked" : wasCancelled ? "cancelled" : blocker.state,
  } as const;
};
